import {Link} from "react-router-dom";

function Footer() {
    return (
        <>
            <section className="newsLetterSec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="title">
                                <h2 className="secHeading" data-aos='fade-up'>
                                    Subscribe for get Daily New Courses
                                </h2>
                                <p data-aos='fade-up' data-aos-delay='100'>
                                    Subscribe to Skill Bridge’s Daily Email News Course and start your day with
                                    knowledge, awareness, and a competitive edge in your chosen field.
                                </p>
                            </div>
                            <form action="" className="newsLetterForm">
                                <div className="inputCont">
                                    <input type="email" placeholder='Enter your email'/>
                                    <button>Subscribe</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <footer>
                <div className="container-md">
                    <div className="row">
                        <div className="col">
                            <Link to="" className="footerLogo">
                                <img src={process.env.PUBLIC_URL + "/images/logo.webp"} alt=""/>
                            </Link>
                            <div className="footerDetails">
                                <p>
                                    Welcome to Skill Bridge, where we are passionate about education, skill development,
                                    and unlocking your full potential. Skill Bridge is not just an institution, it's your
                                    partner on the journey to personal and professional growth.
                                </p>
                                <div className="socials">
                                    <h4>Follow Us</h4>
                                    <Link to="">
                                        <i className="fab fa-twitter"/>
                                    </Link>
                                    <Link to="">
                                        <i className="fab fa-instagram"/>
                                    </Link>
                                    <Link to="">
                                        <i className="fab fa-facebook-f"/>
                                    </Link>
                                    <Link to="">
                                        <i className="fab fa-google"/>
                                    </Link>
                                    <Link to="">
                                        <i className="fab fa-linkedin"/>
                                    </Link>
                                </div>
                                <span className="copyright">
                                    Skilbridge © All Rights Reserved
                                </span>
                            </div>
                        </div>
                        <div className="col">
                            <div className="footerLink">
                                <h4>Quick Links</h4>
                                <ul>
                                    <li>
                                        <Link to="/programs">
                                            Programs
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/events">
                                            Event & Workshop
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/workforce">
                                            Workforce Training
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/hire-grad">
                                            Hire Our grad
                                        </Link>
                                    </li>
                                    {/*<li>*/}
                                    {/*    <Link to="/enterprise">*/}
                                    {/*        Enterprise*/}
                                    {/*    </Link>*/}
                                    {/*</li>*/}
                                    <li>
                                        <Link to="/course-date">
                                            Course date
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div className="footerLink">
                                <h4>Company</h4>
                                <ul>
                                    <li>
                                        <Link to="/apply-now">
                                            Application Form
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/about">
                                            About us
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/remote">
                                            Remote
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/on-site">
                                            On-Site
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/contact">
                                            Contact us
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div className="footerLink">
                                <h4>Legal</h4>
                                <ul>
                                    <li>
                                        <Link to="/terms-and-conditions">
                                            Terms and Conditions
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/privacy-policy">
                                            Privacy Policy
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/student-terms-and-conditions">
                                            Student T & C
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">
                                            Blogs
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/faqs">
                                            FAQs
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer